import * as React from 'react';
/**
 *
 * Original name: add comment
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1034
 *
 */
export const AddCommentLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M21.5 16.5H18V13h-1.5v3.5H13V18h3.5v3.5H18V18h3.5v-1.5Zm-9.5-9c2.858 0 4.325 1.31 4.485 4h1.502v-.04C17.796 7.939 15.67 6 12 6c-3.869 0-6 2.131-6 6 0 3.67 1.939 5.796 5.46 5.986h.04v-1.502c-2.69-.159-4-1.626-4-4.484 0-3.028 1.472-4.5 4.5-4.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
